import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-no-action',
  templateUrl: './no-action.component.html',
  styleUrls: ['./no-action.component.scss'],
})
export class NoActionComponent {
  constructor(public dialogRef: MatDialogRef<NoActionComponent>) {}

  close() {
    this.dialogRef.close();
  }
}
